import { render } from "./BarArrowButton.vue?vue&type=template&id=f174ac14&scoped=true"
import script from "./BarArrowButton.vue?vue&type=script&lang=js"
export * from "./BarArrowButton.vue?vue&type=script&lang=js"

import "./BarArrowButton.vue?vue&type=style&index=0&id=f174ac14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f174ac14"]])

export default __exports__